import config from '../../../config';
import { LogicContext } from '../types';
import { isIFrameMode } from '../utils';

export const setSearchProperties = async (context: LogicContext) => {
  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.${context.searchBarComponent?.id}.properties.visible`,
          value: !context.currentPagePath.includes(
            config.functionalities.search.path
          ),
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.${context.searchBarComponent?.id}.properties.deviceType`,
          value: context.deviceInfo.deviceType,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.SearchHeader.properties.deviceType',
          value: context.deviceInfo.deviceType,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.SearchHistory.properties.deviceType',
          value: context.deviceInfo.deviceType,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.SearchSuggestions.properties.deviceType',
          value: context.deviceInfo.deviceType,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.SearchCategory.properties.deviceType',
          value: context.deviceInfo.deviceType,
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.SearchDesktop.properties.visible',
          value:
            context.currentPagePath.includes(
              config.functionalities.search.path
            ) &&
            context.mainLayoutPath.includes(
              config.functionalities.search.path
            ) &&
            context.deviceInfo.deviceType === 'desktop' &&
            !isIFrameMode(),
        },
      },
    ],
  };
};
